import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { withPrefix } from 'gatsby-link'

import Header from '../components/header'
import Footer from '../components/footer'
import './index.css'

const Layout = ({ children, data }) => (
  <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Header siteTitle={data.site.siteMetadata.title} />
    <div
      dangerouslySetInnerHTML={{
        __html: `
        <script type="application/ld+json">
      { "@context": "http://schema.org",
      "@type": "Organization",
      "name": "ZAPGIGS",
      "legalName" : "ZapGigs",
      "url": "https://www.zapgigs.com",
      "logo": "https://www.zapgigs.com${withPrefix('jsonld-logo.png')}",
      "foundingDate": "2018",
      "founders": [
      {
      "@type": "Person",
      "name": "Lewis Robinson"
      }],
      "address": {
      "@type": "PostalAddress",
      ${/*"streetAddress": "2/9 Austin Crescent",*/ ''}
      "addressLocality": "Melbourne",
      "addressRegion": "VIC",
      "postalCode": "3044",
      "addressCountry": "AUS"
      },
      "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "email": "contact@zapgigs.com",
      "url": "https://www.zapgigs.com/contact"
      },
      "sameAs": [ 
      "http://www.twitter.com/zapgigsHQ"
      ]}
      </script>
    `,
      }}
    />

    <div
      style={{
        margin: '0 auto',
        width: '980px',
        maxWidth: '100%',
        padding: '0px 1.0875rem 4rem',
      }}
    >
      {children()}
    </div>
    <Footer siteTitle={data.site.siteMetadata.title} />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js